<template>
  <div id="login">
    <div class="col1">
      <h3>Inloggen</h3>
      <input type="text" placeholder="email adres" v-model="email" />
      <br />
      <input type="password" placeholder="wachtwoord" v-model="password" />
      <br />
      <button @click="login">inloggen</button>
      <!-- <p>
        Of ga naar
        <router-link to="/signup">registreren</router-link>
      </p> -->
    </div>
  </div>
</template>


<script>
const fb = require("../firebaseConfig.js");

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      env: fb.env
    };
  },
  methods: {
    login: function() {
      fb.auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          this.$store.dispatch("fetchUserProfile");

          this.log("success");

          this.$router.replace("home");
        })
        .catch(error => {
          // log
          this.log(error.message);

          alert("fout: " + error.message);
        });
    },
    log(res) {
      var now = new Date();
      // log
      fb.db.collection("logs").add({
        date: now.toISOString(),
        email: this.email,
        env: this.env,
        app: "admin",
        result: res
      });
    }
  }
};
</script>


<style scoped>
login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>